import React, { useState } from "react";
import { IvSignRedirect } from "../../components/IvSignRedirect/IvSignRedirect";
import Utils from "../../services/Utils";
import { generateIvSignAuthUriMFA, postManagementSignature } from "../../services/signatureMethods/customServiceSignature";

export const IvSignAuth = () => {
  const [error, setError] = useState(null);

  const authorizeProcess = async () => {
    const params = new URLSearchParams(window.location.search);
    const transactionId = params.get('transactionid');

    if (!transactionId) {
      setError('Missing transaction ID.');
      return;
    }

    try {
      // Recover important data from localStorage to sessionStorage
      const token = localStorage.getItem("oauthTokenB64");

      sessionStorage.setItem(
        "AccessMethod",
        localStorage.getItem("AccessMethod")
      );
      sessionStorage.setItem("oauthTokenB64", token);
      sessionStorage.setItem(
        "appearanceConf",
        localStorage.getItem("appearanceConf")
      );
      sessionStorage.setItem(
        "showApprovals",
        localStorage.getItem("showApprovals")
      );
      sessionStorage.setItem("user", localStorage.getItem("user"));

      const body = {
        TransactionGuid: transactionId,
      };

      // Get the user GUID from the token
      const userGuid = Utils.getViDMobileUserGUIDFromOauthToken(token);

      const response = await postManagementSignature(
        generateIvSignAuthUriMFA(userGuid),
        body,
        token
      );

      if (response.status !== 204) {
        throw new Error("Authorization failed");
      }

      // Remove data from localStorage after successful authorization
      localStorage.removeItem("AccessMethod");
      localStorage.removeItem("oauthTokenB64");
      localStorage.removeItem("appearanceConf");
      localStorage.removeItem("showApprovals");
      localStorage.removeItem("user");

      // Redirect to the indicated view
      window.location.href = "/certificates?ivnosysAuthorization=true";
    } catch (err) {
      setError(err.message);
    }
  };

  return <IvSignRedirect error={error} callback={authorizeProcess} />;
};
